import {useCustomPage} from '@common/custom-page/use-custom-page';
import React, {Fragment, Suspense, useEffect} from 'react';
import {PageMetaTags} from '@common/http/page-meta-tags';
import {PageStatus} from '@common/http/page-status';
import {CustomPage} from '@common/admin/custom-pages/custom-page';
import {FormProvider, useForm} from 'react-hook-form';
import {useUpdateCustomPage} from '@common/admin/custom-pages/requests/use-update-custom-page';
import {FileUploadProvider} from '@common/uploads/uploader/file-upload-provider';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {FullPageLoader} from '@common/ui/progress/full-page-loader';
import { Chat } from '@app_modules/chats/chat';
import { ChatEditorStickyHeader } from '../chat-editor/chat-editor-sticky-header';
import { ChatEditorTitle } from '../chat-editor/chat-editor-title';
import { formatMessageToHtml } from '@app_modules/loan-applications/step4/uw-custom-page';

const ChatBodyEditor = React.lazy(
  () => import('../chat-editor/chat-body-editor'),
);

export function UwCustomPage({message}: {message: any}) {
  return (
    <Fragment>
      <ChatContent message={message}/>
    </Fragment>
  );
}

export interface CreateChatPayload {
  body?: string;
}

interface ChatContentProps {
  message: any
}

function ChatContent({message}: ChatContentProps) {
  const navigate = useNavigate();
  const crupdatePage = useUpdateCustomPage();
  const form = useForm<CreateChatPayload>({
    defaultValues: {
      body: message,
    },
  });

  useEffect(() => {
    form.setValue('body', message);
  }, [message])


  const initialContent = formatMessageToHtml(message);

  const handleSave = (editorContent: string) => {
    crupdatePage.mutate(
      {
        ...form.getValues(),
        body: editorContent,
      },
      {
        onSuccess: () => navigate('../..', {relative: 'path'}),
      },
    );
  };

  return (
    <Suspense fallback={<FullPageLoader />}>
      <ChatBodyEditor initialContent={initialContent}>
        {(content, editor) => (
          <FileUploadProvider>
            <FormProvider {...form}>
              {/* <ChatEditorTitle/> */}
              <ChatEditorStickyHeader
                editor={editor}
                backLink="../.."
                isLoading={crupdatePage.isPending}
                onSave={handleSave}
              />

              <div className="mx-20">
                <div className="prose dark:prose-invert mx-auto flex-auto">
                  {content}
                </div>
              </div>
            </FormProvider>
          </FileUploadProvider>
        )}
      </ChatBodyEditor>
    </Suspense>
  );
}
